import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { extendObservable, autorun, autorunAsync, action } from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, TextInput } from '../Form';
import DnD from '../DnD/App';
// import DragDropList from '../DragDropList';
import DragAndDrop from '../DragAndDrop';

@inject('metaDataTemplateStore', 'metaDataStore')
@observer
class MetaDataTemplateEdit extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  };

  slug = '/configurations/meta-data/template';
  title = 'Edit Meta Data Template';
  disposer = null;

  @observable metaDataTemplate = {
    id: '',
    name: '',
    description: '',
    meta_data: [],
  };
  @observable dndLists;

  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
  }

  componentWillMount() {
    const {
      params: { id },
      metaDataTemplateStore, metaDataStore,
    } = this.props;

    this.disposer = autorun(() => {
      metaDataTemplateStore.fetchItem(id);
      metaDataStore.fetchItems();
      const foundMetaDataTemplate = metaDataTemplateStore.findById(id);
      this.resetInputValues(foundMetaDataTemplate);
    });
  }

  componentWillUnmount() { this.disposer(); }

	@action
  resetInputValues(item) {
    if (!item) { return; }
    item.meta_data = item.meta_data.map((md, i) => (Object.assign(md, {seq: !!+md.seq || i+1})))
    this.metaDataTemplate = extendObservable({}, item);
  }

	@action	onChangeName = (e) => { this.metaDataTemplate.name = e.target.value; }
	@action	onChangeDescription = (e) => { this.metaDataTemplate.description = e.target.value; }
	@action	onChangeMetaData = (dndLists) => {
    const metaDataList = dndLists.slice(-1).pop();
    const metaData = metaDataList.items;

    this.metaDataTemplate.meta_data = metaData.map((item, i) => (Object.assign(item, {seq: i+1})));
  }

  handleSave(e) {
    e.preventDefault();

    const { metaDataTemplateStore } = this.props;
    console.log('this.metaDataTemplate', this.metaDataTemplate);
    metaDataTemplateStore.updateItem(this.metaDataTemplate)
      .then(() => {
        this.context.router.push(this.slug);
      });
    // setTimeout(() => {
      // this.context.router.push(this.slug);
    // }, 100);
  }

  @action onChangeDragAndDropLists = (dndLists) => {
    this.dndLists = dndLists;
  }

  render() {
    const {
      metaDataTemplateStore, metaDataStore,
      params: { id },
    } = this.props;

    if (metaDataTemplateStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug}>
        <Form>
          <FormBody>
            <TextInput label={'Id'} value={id} readOnly />
            <TextInput label={'Name'} value={this.metaDataTemplate.name}
              onChange={this.onChangeName}
            />
            <TextInput label={'Description'} value={this.metaDataTemplate.description}
              onChange={this.onChangeDescription}
            />
          </FormBody>

          <DragAndDrop
            lists={[
              {
                id: 1,
                name: 'Meta Data List',
                items: metaDataStore.items.toJS(),
              },
              {
                id: 2,
                name: 'Template Meta Data',
                // dndItems: metaDataItems,
                items: this.metaDataTemplate.meta_data.slice().map(item => item.asJson) || [],
                // items: [
                  // // { id: 999, name: 'Dummy' },
                // ],
              },
            ]}
            onChange={this.onChangeMetaData}
          />
          {/*
          <DnD />
          <DragDropList
            source={{
              title: 'Meta Data List',
              data: metaDataStore.items,
            }}
            target={{
              title: 'Template Meta Data',
              // data: metaDataItems,
              data: this.metaDataTemplate.meta_data,
            }}
            onChange={this.onChangeMetaData}
          />
          */}

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


export default MetaDataTemplateEdit;



// WEBPACK FOOTER //
// ./src/components/MetaDataTemplate/MetaDataTemplateEdit.js